import { useEffect } from "react"

const eventBus = {
    on<EventName extends string, Data>(event: EventName, callback: (data: Data) => void) {
        console.log(`Event ${event} subscribed`)
        document.addEventListener(event, (e) => callback((e as unknown as { detail: Data }).detail), false)
    },
    dispatch<EventName extends string, Data>(event: EventName, data?: Data) {
        console.log(`Event ${event} dispatched`)
        document.dispatchEvent(new CustomEvent(event, { detail: data }))
    },
    remove<EventName extends string>(event: EventName, callback: (data: Event) => void) {
        console.log(`Event ${event} unsubscribed`)
        document.removeEventListener(event, callback)
    },
}

export default eventBus

export function useEventBusListener(eventName: string, callback: (data?: any) => void) {
    useEffect(() => {
        const loggingCallback = new Proxy(callback, {
            apply(target, _thisArg, argArray) {
                console.log(`Event ${eventName} received`, argArray)
                return target(...argArray)
            },
        })

        eventBus.on(eventName, loggingCallback)

        return () => {
            eventBus.remove(eventName, loggingCallback)
        }
    }, [eventName, callback])
}
